import { Link } from '@remix-run/react'
import { type ReactNode } from 'react'

interface LegalPageLayoutProps {
	title: string
	intro: string
	children: ReactNode
}

export function LegalPageLayout({
	title,
	intro,
	children,
}: LegalPageLayoutProps) {
	return (
		<main className="pb-16 pt-8 md:pt-12">
			<div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
				<div className="mb-8 flex items-center gap-2 text-sm text-muted-foreground">
					<Link to="/" className="font-semibold text-brand hover:text-brand/80">
						Inicio
					</Link>
					<span>/</span>
					<span>Información legal</span>
				</div>

				<header className="mb-8 rounded-3xl border border-slate-200 bg-white p-6 shadow-sm md:p-8">
					<p className="mb-2 text-xs font-bold uppercase tracking-[0.2em] text-brand">
						Asociación Síndrome PCDH19
					</p>
					<h1 className="font-heading text-3xl font-extrabold text-slate-900 md:text-4xl">
						{title}
					</h1>
					<p className="mt-4 max-w-3xl text-base leading-7 text-slate-700 md:text-lg">
						{intro}
					</p>
					<p className="mt-4 text-sm text-slate-500">Última actualización: diciembre de 2025</p>
				</header>

				<article className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm md:p-10">
					<div className="prose prose-slate max-w-none prose-headings:font-heading prose-headings:text-slate-900 prose-h2:mt-10 prose-h2:text-2xl prose-h3:mt-7 prose-h3:text-xl prose-p:leading-7 prose-a:text-brand prose-a:no-underline hover:prose-a:text-brand/80 prose-strong:text-slate-900">
						{children}
					</div>
				</article>
			</div>
		</main>
	)
}
